import { render } from "./BroadcastGivingCard.vue?vue&type=template&id=a44651e4"
import script from "./BroadcastGivingCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BroadcastGivingCard.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Sites/Broadcast/BroadcastGivingCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a44651e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a44651e4', __exports__)) {
    api.reload('a44651e4', __exports__)
  }
  
  module.hot.accept("./BroadcastGivingCard.vue?vue&type=template&id=a44651e4", () => {
    api.rerender('a44651e4', render)
  })

}


export default __exports__